import type { Locale } from 'date-fns';

export type DateRange = {
  startDate?: Date;
  endDate?: Date;
};

export type Marker = symbol;

export enum NavigationAction {
  Previous = -1,
  Next = 1,
}

export type DateRangePickerProps = {
  initialDateRange?: DateRange;
  minDate?: Date | string;
  maxDate?: Date | string;
  locale?: Locale;
  onChange?: (dateRange: DateRange) => void;
  hideOutsideMonthDays?: boolean;
};
